import { defaultFields } from '../../data'
import store from '@/store/index'

export default  {
	filterBox(state){
		const {fieldsToFilter} = state
		let newFilterField = []
		if(fieldsToFilter.length > 0){
			fieldsToFilter.forEach(list => {
				let newField = {
					key : list.label,
					label : list.field_name,
					sortable: true, thClass: 'bg-warning', thStyle: { borderTop: 0, verticalAlign: 'middle' }
				}
				newFilterField.push(newField)
			})
			if(newFilterField.length > 0){
				let mergeFilter = [...defaultFields, ...newFilterField]
				const unique = mergeFilter
					.map(e => e['key'])
					.map((e, i, final) => final.indexOf(e) === i && i)
					.filter(obj=> mergeFilter[obj])
					.map(e => mergeFilter[e]);
				
				state.tableFields = unique
			} else {
				state.tableFields = defaultFields
			}
		} else {
			state.tableFields = defaultFields
		}
	}
}
